import { EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Marks a product that is hidden from the customer shop but bookable by staff. */
export default function HiddenProductBadge() {
  const { t } = useTranslation();
  return (
    <span className="badge badge-warning text-xs inline-flex items-center gap-xs" data-testid="hidden-product-badge">
      <EyeOff className="w-3 h-3" />
      {t('products.hiddenLabel')}
    </span>
  );
}
